import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import type { ExtendedApplication } from '../model/application';
import type { FindApplicationsRequestParams } from '../model/find-applications-params';
import type { FindApplicationsResponse } from '../model/find-applications-response';

const BASE_URL = `${config.apiHost}/merchant-portal/api/v1/public/dashboard`;

export async function findApplications(
  params: FindApplicationsRequestParams
): Promise<FindApplicationsResponse> {
  const res = await makeRequest<{ payload: FindApplicationsResponse }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/applications`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}

export async function getApplicationById(
  applicationId: string
): Promise<ExtendedApplication> {
  const res = await makeRequest<{ payload: ExtendedApplication }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/applications/get-by-id`,
    withCredentials: true,
    timeout: 60_000,
    payload: { applicationId },
  });
  return res.payload;
}

export async function generateApplicationsReport(
  params: FindApplicationsRequestParams
): Promise<{ reportId: string }> {
  const res = await makeRequest<{ payload: { reportId: string } }>({
    httpMethod: 'POST',
    type: 'json',
    url: `${BASE_URL}/run-applications-export`,
    withCredentials: true,
    timeout: 60_000,
    payload: params,
  });
  return res.payload;
}
